/** Picks the web chat block backend: mock (default dev/screens mode) or the real API (same origin/session). */
import { useMock } from '../index'
import { HttpWcBlockApi } from './http'
import { MockWcBlockApi } from './mock'
import type { WcBlockApi } from './types'

let current: WcBlockApi | null = null

export function getWcBlockApi(): WcBlockApi {
  if (!current) current = useMock ? new MockWcBlockApi() : new HttpWcBlockApi((import.meta.env.VITE_API_BASE ?? '').trim())
  return current
}

/** Tests inject their own backend. */
export function setWcBlockApi(api: WcBlockApi | null): void {
  current = api
}

export type * from './types'
